import * as Yup from 'yup'

import { useEffect, useState } from "react"

import { ICheckBoxProps } from './ICheckBoxProps'

export const useCheckBoxValidationSchema = (props: ICheckBoxProps) => {
    const [schema, setSchema] = useState<Yup.BooleanSchema>();

    useEffect(() => {
        const { label, required } = props

        let schema = Yup.boolean()

        if (required)
            schema = schema.required();

        if (label)
            schema = schema.label(label);


        setSchema(schema)
        // eslint-disable-next-line
    }, [props])

    return schema
}
